// extracted by mini-css-extract-plugin
module.exports = {"contTab":"ChatV1Tab_contTab__2cjZs","tab":"ChatV1Tab_tab__16o-j","activate":"ChatV1Tab_activate__DJ0sw"};